import React, { useContext } from 'react';
import { Image } from '../../../components';
import { getMediaImage } from '../../../components/Media/Image/utils';
import RouterLink from '../../../components/RouterLink/RouterLink';
import { ThemeValueContext } from '../../../context/theme/ThemeValueContext';
import { block, getThemedValue } from '../../../utils';
import './Logo.css';
const b = block('logo');
const Logo = (props) => {
    const { themeValue: theme } = useContext(ThemeValueContext);
    const themedLogoProps = getThemedValue(props, theme) || props;
    const imageData = getMediaImage(themedLogoProps.icon || props.icon);
    const textData = themedLogoProps.text || props.text;
    return (React.createElement(RouterLink, { href: themedLogoProps.url || props.url || '/', passHref: true },
        React.createElement("div", { className: b(null, props.className) },
            imageData && React.createElement(Image, Object.assign({ className: b('icon') }, imageData)),
            React.createElement("span", { className: b('text') }, textData))));
};
export default Logo;
